import { useId, useLayoutEffect, useRef, useState } from 'react';
import { reducedMotion } from '../../lib/motion.js';

/** Mouse controls stay outside the scrolling segments; touch keeps native scrolling. */
export default function TabScroller({ children }) {
  const frame = useRef(null);
  const id = useId();
  const [trackId, setTrackId] = useState(id);
  const [edges, setEdges] = useState({ overflow:false, left:false, right:false });
  useLayoutEffect(() => {
    const element = frame.current.querySelector('.tab-nav');
    if (!element) return undefined;
    element.id ||= id;
    setTrackId(element.id);
    function update() {
      if (!element.isConnected) return;
      const style = getComputedStyle(element);
      const tabs = [...element.querySelectorAll('.tab-btn')];
      const width = tabs.reduce((sum,tab) => sum + tab.getBoundingClientRect().width,0)
        + Math.max(0,tabs.length - 1) * (parseFloat(style.columnGap) || 0)
        + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + element.offsetWidth - element.clientWidth;
      const next = { overflow:width > frame.current.clientWidth + 1, left:element.scrollLeft > 2,
        right:element.scrollWidth - element.clientWidth - element.scrollLeft > 2 };
      setEdges(previous => Object.keys(next).every(key => previous[key] === next[key]) ? previous : next);
    }
    const observer = new ResizeObserver(update);
    [frame.current,element,...element.querySelectorAll('.tab-btn')].forEach(node => observer.observe(node));
    element.addEventListener('scroll',update,{passive:true});
    update();
    return () => { observer.disconnect(); element.removeEventListener('scroll',update); };
  }, [children, id]);
  const move = direction => {
    const track = frame.current.querySelector('.tab-nav');
    track?.scrollBy({left:direction * track.clientWidth * .75,behavior:reducedMotion() ? 'instant' : 'smooth'});
  };
  return <div ref={frame} className="navigation-tab-scroller" data-overflow={edges.overflow} data-left={edges.left} data-right={edges.right}>
    <button type="button" className="tabs-scroll-arrow" aria-label="Pestañas anteriores" aria-controls={trackId} disabled={!edges.left} onClick={() => move(-1)}><span className="material-symbols-rounded" aria-hidden="true">chevron_left</span></button>
    {children}
    <button type="button" className="tabs-scroll-arrow" aria-label="Pestañas siguientes" aria-controls={trackId} disabled={!edges.right} onClick={() => move(1)}><span className="material-symbols-rounded" aria-hidden="true">chevron_right</span></button>
  </div>;
}
